module.exports = __webpack_public_path__ + "img/9788991963207.41a09cec.jpg";